import React from 'react';
import { useB2BTranslation } from '../../B2BShared/hooks/useB2BTranslation';

interface B2BParticipantHeaderProps {
  name: string;
  surname: string;
  position: string | string[];
  profilePhoto?: string | null;
  isEditing?: boolean;
}

const B2BParticipantHeader: React.FC<B2BParticipantHeaderProps> = ({
  name,
  surname,
  position,
  profilePhoto,
  isEditing = false
}) => {
  const { t } = useB2BTranslation();
  const [imageError, setImageError] = React.useState(false);

  if (isEditing) {
    return (
      <div className="card-header">
        <h3>{t('buttons.editProfile')}</h3>
      </div>
    );
  }

  return (
    <div className="card-header">
      <div className="avatar-container">
        {profilePhoto && !imageError && (
          <img
            src={profilePhoto}
            alt={`${name} ${surname}`}
            className="avatar-image"
            onError={() => setImageError(true)}
          />
        )}
      </div>
      <h3 className="participant-name">
        {name} {surname}
      </h3>
      <p className="participant-position">
        {Array.isArray(position) ? position.join(', ') : position}
      </p>
    </div>
  );
};

export default B2BParticipantHeader;
